import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from 'Utils';

export default class CalculatorInput extends React.Component {
  static handleDecimals(value, isPercent) {
    if (value.includes('.')) {
      // Grab index of first occurence of decimal point
      const decimals = value.substr(value.indexOf('.'));
      if (isPercent) {
        // Matches one '.' followed by an arbitrary amount of numbers
        return /^(\.[0-9]*)$/.test(decimals);
      }
      // Matches one '.' followed by at most two numbers.
      return /^(\.[0-9]?[0-9]?)$/.test(decimals);
    }
    return false;
  }

  constructor() {
    super();
    this.state = {
      placeholder: '0',
    };
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleMonetaryOnChange = this.handleMonetaryOnChange.bind(this);
    this.handleIntegerOnChange = this.handleIntegerOnChange.bind(this);
    this.handlePercentOnChange = this.handlePercentOnChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.getInputClasss = this.getInputClass.bind(this);
  }

  getInputClass() {
    if (this.props.type === 'monetary') {
      return 'monetary';
    } else if (this.props.type === 'percent') {
      return 'percent';
    }
    return '';
  }

  handleFocus() {
    this.setState({ placeholder: '' });
  }

  handleBlur() {
    this.setState({ placeholder: '0' });
  }

  handleMonetaryOnChange(value) {
    // Fix to two decimal places, ignore trailing zeros
    const parsedValue = Number(parseFloat(value).toFixed(2));
    if (isNaN(parsedValue)) {
      return this.props.onChange('0');
    }
    if (CalculatorInput.handleDecimals(value)) {
      return this.props.onChange(value);
    }
    return this.props.onChange(String(parsedValue));
  }

  handleIntegerOnChange(value) {
    const parsedValue = Number(Math.round(parseFloat(value)));
    if (isNaN(parsedValue)) {
      return this.props.onChange('0');
    }
    return this.props.onChange(String(parsedValue));
  }

  handlePercentOnChange(value) {
    const parsedValue = Number(parseFloat(value));
    if (isNaN(parsedValue)) {
      return this.props.onChange('0');
    }
    if (CalculatorInput.handleDecimals(value, true)) {
      return this.props.onChange(value);
    }
    return this.props.onChange(String(parsedValue));
  }

  // Custom handler for currency.
  // Handles formated values like 500,000 and allows
  // user to enter partial state 2. and 2.0
  handleOnChange(e) {
    if (this.props.disabled) {
      return false;
    }

    let value = e.target.value.replace(/,/g, '');
    value = this.props.negativeAllowed ? value : value.replace(/-/g, '');
    switch (this.props.type) {
      case 'monetary':
        return this.handleMonetaryOnChange(value);
      case 'percent':
        return this.handlePercentOnChange(value);
      default:
        return this.handleIntegerOnChange(value);
    }
  }

  render() {
    const value = (this.props.value === '' || this.props.value === '0') ? '' : formatNumber(this.props.value);
    const inputClassName = this.getInputClass();

    return (
      <div className={`custom-input-wrap ${this.props.className}`}>
        <div className="custom-input-details">
          <h4>{this.props.title}</h4>
          {this.props.description &&
            <p>{this.props.description}</p>
          }
        </div>
        <div className={`custom-input ${inputClassName}`}>
          <input
            type="text"
            onChange={this.handleOnChange}
            placeholder={this.state.placeholder}
            value={value}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            disabled={this.props.disabled}
          />
        </div>
      </div>
    );
  }
}

CalculatorInput.defaultProps = {
  className: '',
  description: '',
  disabled: false,
  onChange: () => null,
  type: 'integer',
  negativeAllowed: false,
};

CalculatorInput.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  negativeAllowed: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/CalculatorInput/index.jsx